import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.91,9a.76.76,0,0,1-.75-.75V5.8a.75.75,0,0,1,1.5,0V8.27A.75.75,0,0,1,7.91,9Zm7.14,4.54a1.92,1.92,0,0,1-1.68.93H2.45a1.92,1.92,0,0,1-1.68-.93,2.19,2.19,0,0,1,0-2.17c.3-.56,1.77-3.13,3.08-5.43L6.07,2.14a2,2,0,0,1,3.68,0c.16.3,1.15,2,2.23,3.91,1.3,2.28,2.73,4.79,3,5.34A2.19,2.19,0,0,1,15.05,13.56ZM13.7,12.1c-.3-.54-1.73-3-3-5.31L8.43,2.86c-.26-.49-.37-.49-.52-.49s-.26,0-.52.49L5.2,6.7C3.89,9,2.42,11.55,2.12,12.1a.74.74,0,0,0-.06.7.42.42,0,0,0,.39.19H13.37a.42.42,0,0,0,.39-.19A.74.74,0,0,0,13.7,12.1Zm-5.79.34a1,1,0,1,0-1-1A1,1,0,0,0,7.91,12.44Z';
const draw24px =
  'M12,14.37a.75.75,0,0,1-.75-.75V8.09a.75.75,0,0,1,1.5,0v5.53A.74.74,0,0,1,12,14.37Zm10.39,5.79a2.51,2.51,0,0,1-2.2,1.21H3.8a2.51,2.51,0,0,1-2.19-1.21,2.92,2.92,0,0,1,0-2.9c.46-.83,2.65-4.67,4.59-8.07C7.86,6.38,9.32,3.83,9.57,3.38a2.58,2.58,0,0,1,4.86,0c.24.45,1.71,3,3.31,5.81,1.94,3.4,4.14,7.24,4.59,8.07A2.92,2.92,0,0,1,22.39,20.16ZM21,18c-.44-.82-2.64-4.66-4.57-8-1.61-2.82-3.08-5.39-3.33-5.85-.5-.92-.8-.92-1.11-.92s-.61,0-1.12.92c-.24.46-1.71,3-3.32,5.85C5.62,13.32,3.43,17.16,3,18a1.41,1.41,0,0,0-.08,1.41,1,1,0,0,0,.9.48H20.19a1,1,0,0,0,.91-.48A1.44,1.44,0,0,0,21,18Zm-9,.13a1,1,0,1,0-1-1A1,1,0,0,0,12,18.11Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const AlertWarningIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'alertWarning'),
) as IconWithRender;

AlertWarningIcon.displayName = 'AlertWarningIcon';
AlertWarningIcon.propTypes = Icon.propTypes;
AlertWarningIcon.renderIcon = (props) => <AlertWarningIcon {...props} />;
export default AlertWarningIcon;
